module.exports = __webpack_public_path__ + "img/how_to_use01_img.941ddb06.png";